module.exports = __webpack_public_path__ + "static/media/Meals_Small.8e102ba0.png";